import { inject, Injectable } from "@angular/core";
import { MsalService } from "@azure/msal-angular";
import { from, Observable, throwError } from "rxjs";
import { MS_SCOPES } from "../models/msal.config";
import {
  AuthenticationResult,
  InteractionRequiredAuthError,
} from "@azure/msal-browser";
import { catchError, map } from "rxjs/operators";
import { localStorageKeys } from "../models/localStorageKeys";
import { AuthenticationService } from "./auth.service";

@Injectable({ providedIn: "root" })
export class MsalTokenService {
  constructor(
    private msalService: MsalService,
    private auth: AuthenticationService,
  ) {}

  getMicrosoftToken(forceRefresh = false): Observable<string> {
    const account =
      this.msalService.instance.getActiveAccount() ||
      this.msalService.instance.getAllAccounts()[0];

    if (!account) {
      this.auth.logout();
      return throwError(() => new Error("No active Microsoft account"));
    }

    const request = {
      scopes: MS_SCOPES,
      account: account,
    };

    return this.msalService.acquireTokenSilent(request).pipe(
      map((result: AuthenticationResult) => {
        console.log("Token expires at:", new Date(+result.expiresOn!));
        localStorage.setItem(localStorageKeys.MT, result.accessToken);
        return result.accessToken;
      }),
      catchError((error) => {
        if (error instanceof InteractionRequiredAuthError) {
          console.warn("Silent failed → falling back to popup");
          return this.msalService.acquireTokenPopup(request).pipe(
            map((result) => {
              localStorage.setItem(localStorageKeys.MT, result.accessToken);
              return result.accessToken;
            }),
            catchError((err) => {
              this.auth.logout();
              return throwError(err);
            }),
          );
        }
        return throwError(() => error);
      }),
    );
  }
}
